import { cache } from "lib/apolloClient";
import { getUnitCombinedLibraryQuery } from "./Query";

export const getUnitCombinedLibraryQueryFromCache = variables => {
  return cache.readQuery({
    query: getUnitCombinedLibraryQuery,
    variables,
  });
};

export const writeUnitCombinedLibraryQueryInCache = ({ variables, data }) => {
  cache.writeQuery({
    query: getUnitCombinedLibraryQuery,
    variables,
    data,
  });
};
